import './Spacer.css';
export const Spacer = () => {
  return <div className="spr_spacer" />;
};
